/* global denvaAjax */
/**
 * Newsletter signup - jQuery validation + AJAX submit.
 *
 * Works with multiple .js-newsletter-form instances on the same page
 * (footer + popup block) without ID conflicts.
 *
 * @package denva
 */

jQuery( document ).ready( function( $ ) {
	var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	$( '.js-newsletter-form' ).each( function() {
		var $form   = $( this );
		var $email  = $form.find( '[name="newsletter_email"]' );
		var $check  = $form.find( '[name="newsletter_consent"]' );
		var $btn    = $form.find( 'button[type="submit"]' );
		var $status = $form.find( '.newsletter-status' );

		function setStatus( type, message ) {
			$status.text( message )
				.removeClass( 'newsletter-status--success newsletter-status--error' );
			if ( type ) {
				$status.addClass( 'newsletter-status--' + type );
			}
		}

		function clearError( $field ) {
			$field.removeClass( 'has-error' );
			$field.removeAttr( 'aria-invalid' );
		}

		$email.on( 'input', function() { clearError( $email ); } );
		$check.on( 'change', function() { clearError( $check ); } );

		$form.on( 'submit', function( e ) {
			e.preventDefault();
			var valid = true;

			// Validate email.
			if ( ! $email.val().trim() || ! emailRegex.test( $email.val().trim() ) ) {
				$email.addClass( 'has-error' );
				$email.attr( 'aria-invalid', 'true' );
				valid = false;
			}

			// Validate consent.
			if ( ! $check.is( ':checked' ) ) {
				$check.addClass( 'has-error' );
				$check.attr( 'aria-invalid', 'true' );
				valid = false;
			}

			if ( ! valid ) {
				setStatus( 'error', 'Vyplňte e-mail a odsúhlaste spracovanie údajov.' );
				return;
			}

			$btn.prop( 'disabled', true ).addClass( 'is-loading' );
			setStatus( '', '' );

			var data = new FormData( $form[0] );
			data.append( 'action', 'denva_newsletter' );

			$.ajax( {
				url: denvaAjax.url,
				type: 'POST',
				data: data,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function( res ) {
					if ( res.success ) {
						setStatus( 'success', res.data.message );
						$form[0].reset();
					} else {
						setStatus( 'error', res.data.message || 'Nastala chyba.' );
					}
				},
				error: function() {
					setStatus( 'error', 'Nastala chyba pri odoslaní.' );
				},
				complete: function() {
					$btn.prop( 'disabled', false ).removeClass( 'is-loading' );
				}
			} );
		} );
	} );
} );
